export default __webpack_public_path__ + "static/media/image_scientist_mobile.d1a45e7e.png";